import { EssayPreviewComponent } from './preview/essay-preview.component';
import { EssayEditComponent } from './edit/essay-edit.component';
import { EssayAiChangePreviewComponent } from './ai-change-preview';
import { EssayGradingComponent } from './grading/essay-grading.component';
import { EssayReportComponent } from './report/essay-report.component';
import { EssayAnswerComponent } from './answer';
export var ESSAY_REGISTRY = {
  edit: EssayEditComponent,
  preview: EssayPreviewComponent,
  'ai-change-preview': EssayAiChangePreviewComponent,
  grading: EssayGradingComponent,
  report: EssayReportComponent,
  answer: EssayAnswerComponent
};